import { Injectable } from '@angular/core';
import { PaymentData } from '../components/payment/payment.component';

@Injectable({
  providedIn: 'root',
})
export class PaymentDataService {
  private paymentData: PaymentData | null = null;

  setPaymentData(data: PaymentData): void {
    this.paymentData = data;
  }

  getPaymentData(): PaymentData | null {
    return this.paymentData;
  }

  clearPaymentData(): void {
    this.paymentData = null;
  }
}
